import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EmptyCheckbox from '../../../../assets/lernsets/icons/checkbox.svg';
import SelectedCheckbox from '../../../../assets/lernsets/icons/selectedCheckbox.svg';
import { palette, spaces } from '../../../../assets/styles/themes/tokens';

interface CollectionVisibilityProps {
  inputRef: React.Ref<HTMLInputElement>;
  initialValue?: boolean;
}

const CollectionVisibility = ({ inputRef, initialValue = false }: CollectionVisibilityProps) => {
  const { t } = useTranslation();

  return (
    <Box data-testid='collection-visibility-container'>
      <FormControlLabel
        sx={{
          margin: 0,
          '& .MuiFormControlLabel-label': {
            color: palette.text.primary,
          },
        }}
        control={
          <Checkbox
            name='isPublic'
            color='primary'
            size='small'
            data-testid='collection-visibility-input'
            icon={<EmptyCheckbox />}
            checkedIcon={<SelectedCheckbox />}
            defaultChecked={initialValue}
            inputRef={inputRef}
            sx={{
              p: 0,
              mr: spaces.xs,
            }}
          />
        }
        labelPlacement='end'
        label={
          <Typography variant='body1' color={palette.text.primary}>
            {t('Public')}
          </Typography>
        }
      />
    </Box>
  );
};

export default CollectionVisibility;
